import { DataTable } from "@/components/data-table/data-table.tsx";
import { columns } from "@/components/onboarding/columns.tsx";
import { Filters } from "@/components/onboarding/filters.tsx";
import { useUsers } from "@/lib/api/user";
import { useDataTable } from "@/lib/hooks/use-data-table.ts";
import { createFileRoute, useRouter, useSearch } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/onboarding/")({
  component: Onboarding,
});

function Onboarding() {
  const router = useRouter();
  const { page, search, per_page } = useSearch({
    strict: false,
  }) as Record<string, string>;

  const currentPage = parseInt(page || "1", 10);
  const pageSize = parseInt(per_page || "1000", 10);

  const { data, isPending } = useUsers({
    page: currentPage,
    perPage: pageSize,
    search,
    assignedRole: "mentee",
  });

  const { table } = useDataTable({
    columns,
    data: data?.users || [],
    defaultPerPage: pageSize,
    pageCount: -1, // Always use -1 for infinite pagination
    filterFields: [],
  });

  const handlePageChange = (newPageIndex: number) => {
    const newPage = newPageIndex + 1;
    router.navigate({
      to: router.state.location.pathname,
      search: (prev: any) => ({
        ...prev,
        page: newPage,
      }),
    });
  };

  const handlePageSizeChange = (newPageSize: number) => {
    router.navigate({
      to: router.state.location.pathname,
      search: (prev: any) => ({
        ...prev,
        page: 1, // Reset to first page when changing page size
        per_page: newPageSize,
      }),
    });
  };

  return (
    <div className="m-6 pb-16">
      <h1 className="mb-6 text-2xl font-bold">Onboarding Data</h1>

      <DataTable
        table={table}
        getCanNextPage={() => {
          return !data?.isLastPage;
        }}
        getCanPreviousPage={() => {
          return currentPage > 1;
        }}
        isPending={isPending}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      >
        <Filters />
      </DataTable>
    </div>
  );
}
